<script>
import pagination from "@/mixins/pagination";
import ReservationFrequencyTypeBadge from "@/components/Common/ReservationFrequencyTypeBadge.vue";
import CommonTableComponent from "@/components/table.vue";
import tableSearch from "@/mixins/tableSearch";
import apiEndpoints from "@/services/apiEndpoints";
import router from "@/mixins/router";
import schedule from "@/state/modules/schedule";
import { create } from "lodash";

export default {
  name: "notificationHazardous",
  mixins: [pagination, tableSearch, router],
  components: {
    CommonTableComponent,
    ReservationFrequencyTypeBadge,
  },
  data() {
    return {
      filters: {
        page: 1,
        column: this.$route.query.column || "schedule_start_datetime",
        dir: this.$route.query.dir || "ASC"
      },
      busyGetData: false,
      notifications: [],
      result_per_page: this.$constant.max_records_per_page,
      isExpanded: false,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      this.busyGetData = true;
      const response = await this.$http.get(apiEndpoints.top_notification_hazardous_reservations, {
        ...this.filters,
      });
      const {status, data} = response;
      this.busyGetData = false;
      if (status) {
        const result = data.result;
        this.notifications = this.$_.isEmpty(result.data) ? [] : result.data;
        const meta = this.$_.isEmpty(result.meta) ? [] : result.meta;
        this.setMeta(meta);
      }
    },
    updateUrlFilters() {
      this.getData()
    },
    toggleItem() {
      this.isExpanded = !this.isExpanded;
    },
    createQueryParam(item) {
      return {
        source: 'calendar',
        schedule_id: item.schedule_id,
        zz_reservation_frequency_type_id: item.zz_reservation_frequency_type_id
      };
    },
  },
  watch: {
    'filters.page': {
      immediate: false,
      handler() {
        this.getData();
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "予約日",
          value: "reserved_at",
          sortable: true,
          width: 10
        },
        {
          text: "作業実施日",
          value: "schedule_start_datetime",
          sortable: true,
          width: 10
        },
        {
          text: "作業内容",
          value: "work_order_name",
          sortable: true,
          width: 80
        }
      ];
    },
    queryPage() {
      return this.$route.query;
    },
    urlDetail() {
      // 配車課スケジュール詳細固定
      return 'projects.work_reservations.schedule.detail'
    },
  },
};
</script>

<template>
  <div class="row">
    <b-overlay
      :show="busyGetData"
      rounded
      opacity="0.6"
      spinner-small
      spinner-variant="primary"
      class="d-inline-block"
    >

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div
              @click="toggleItem()"
              v-b-toggle.collapse-notification-hazardous
              class="card-title mb-2 mt-2"
            >
              <span class="font-size-16">要注意廃棄物予約（{{ meta.total }}件）</span>
              <span :class="{'rotate': isExpanded}" class="icon">▼</span>
            </div>
            <b-collapse id="collapse-notification-hazardous">
              <CommonTableComponent :scrollAble="notifications.length >= this.$constant.scroll_able_records">
                <thead class="table-light">
                <tr>
                  <th
                    :style="`width: ${item.width}`"
                    v-for="(item, index) in headers"
                    :key="index"
                    :class="getHeaderClass(item)"
                  >
                    <span v-if="item.sortable" @click="clickSort(item.value)">
                      {{ item.text }}
                      <i :class="getSortClass(item.value)"></i>
                    </span>
                    <span v-else>
                      {{ item.text }}
                    </span>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in notifications" :key="index"
                  @click.exact="
                    redirectRoute(
                      urlDetail,
                      {
                        work_reservation_id: item.work_reservation_id,
                      },
                      createQueryParam(item),
                      queryPage,
                      'schedules'
                    )
                  "
                  @click.ctrl="
                        redirectRouteTargetBlank(
                          urlDetail,
                          {
                            work_reservation_id: item.work_reservation_id,
                          },
                          createQueryParam(item),
                          queryPage,
                          'schedules'
                        )
                      "
                  class="cursor-pointer"
                >
                  <td>
                    {{ item.reserved_at | shortDate }}
                  </td>
                  <td>
                    {{ item.schedule_start_datetime | shortDate }}
                  </td>
                  <td>
                    <ReservationFrequencyTypeBadge
                      :reservation-frequency-type-id="item.zz_reservation_frequency_type_id"
                    />
                    {{ item.work_order_name }}
                  </td>
                </tr>
                <tr v-if="!notifications.length && !busyGetData">
                  <td colspan="7" class="text-center">
                    通知はありません
                  </td>
                </tr>
                </tbody>
              </CommonTableComponent>
            </b-collapse>
          </div>
        </div>
      </div>
    </b-overlay> 
  </div>
</template>
<style scoped>
.icon {
  float: right;
  transition: transform 0.3s;
}
.rotate {
  transform: rotate(-90deg);
}
</style>
